import WorklogDetail from './WorklogDetail';

export default WorklogDetail;
